import { TranslateService } from "@ngx-translate/core";
import { UserContext } from "../../../../common";
import { MenuItem } from "../../../../views/layout/sidebar/menu.model";
import { DeliveryInstructionManagementPermissions } from "../../permissions";

export const getDeliveryInstructionManagementMenu: (
  userContext?: UserContext,
  translate?: TranslateService
) => MenuItem[] = (userContext?: UserContext, translate?: TranslateService) => {
  const hasAccessToDeliveryInstructionManagement =
      userContext?.hasPermission(DeliveryInstructionManagementPermissions.DeliveryInstructions.ReadAll);
  return [
    {
      id: 17,
      label: translate ? translate.instant('MENUS.DELIVERY_INSTRUCTIONS') : 'Delivery Instructions',
      isHidden: !hasAccessToDeliveryInstructionManagement,
      icon: 'pi pi-truck',
      expanded: true,
      link: `delivery/instructions`,
    }
  ];
};
